"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Icon: true,
  ICON_SIZES: true
};
Object.defineProperty(exports, "ICON_SIZES", {
  enumerable: true,
  get: function () {
    return _helpers.ICON_SIZES;
  }
});
exports.default = exports.Icon = void 0;
var _bind = _interopRequireDefault(require("classnames/bind"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _manifest_svg_icons = _interopRequireDefault(require("./manifest_svg_icons"));
var _SvgIcon = require("./_SvgIcon");
var _helpers = require("./_helpers");
var _Icon = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Icon.css") : void 0);
var _Icon2 = require("./Icon.types");
Object.keys(_Icon2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Icon2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Icon2[key];
    }
  });
});
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

// generated; see scripts/buildIconManifest.js

const CSS_BLOCK = 'sapcnqr-icon';
/**
 * **Icon** components are either used to decorate a site or application or
 * convey meaning for certain elements within a site or application.
 */
const Icon = exports.Icon = /*#__PURE__*/_react.default.forwardRef((_props, ref) => {
  const addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  const props = addChildProps ? Object.assign(Object.assign({}, _props), addChildProps(Icon, _props)) : _props;
  const {
      ariaHidden,
      ariaLabel,
      className,
      forceSize,
      iconName,
      path1ClassName,
      path2ClassName,
      role = 'img',
      size = 'sm'
    } = props,
    otherProps = __rest(props, ["ariaHidden", "ariaLabel", "className", "forceSize", "iconName", "path1ClassName", "path2ClassName", "role", "size"]);
  const classnames = _bind.default.bind(_Icon.default);
  const baseClasses = classnames(CSS_BLOCK, `${CSS_BLOCK}--${iconName}`, `${CSS_BLOCK}--${forceSize || size}`, className);
  if (_manifest_svg_icons.default.some(iconNm => iconNm === iconName)) {
    return /*#__PURE__*/_react.default.createElement(_SvgIcon.SvgIcon, Object.assign({}, otherProps, {
      ariaHidden: ariaHidden,
      "aria-label": ariaLabel,
      className: baseClasses,
      iconName: iconName,
      path1ClassName: path1ClassName,
      path2ClassName: path2ClassName,
      ref: ref,
      size: forceSize || size,
      title: ariaLabel
    }));
  }
  return /*#__PURE__*/_react.default.createElement("i", Object.assign({}, otherProps, {
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel,
    className: baseClasses,
    ref: ref,
    role: ariaHidden ? undefined : role
  }));
});
Icon.displayName = 'Icon';
var _default = exports.default = Icon;